module.exports = __webpack_public_path__ + "static/img/starpage-title.2f6247cb.png";